import { Link as CLink, LinkProps as CLinkProps } from '@chakra-ui/react'
import { Link as RLink, LinkProps as RLinkProps } from 'react-router-dom'

export type LinkProps = Exclude<CLinkProps, 'as' | 'to'> &
  RLinkProps & {
    search?: Record<
      string,
      string | number | boolean | null | undefined | [] | Record<string, any>
    >
    isDisabled?: boolean
  }

export const Link = ({ to, search, ...props }: LinkProps) => {
  return (
    <CLink
      to={typeof to === 'string' ? createLink(to, search) : to}
      {...props}
      as={RLink}
    />
  )
}

export const ConditionalLink = ({
  to,
  children,
  isDisabled,
  ...props
}: Partial<LinkProps>) => {
  if (!to || isDisabled) return children

  return (
    <Link to={to} {...props}>
      {children}
    </Link>
  )
}

export const createLink = (url?: string, search?: Record<string, any>) => {
  if (!url) return ''

  if (!search) return url

  const params = new URLSearchParams()

  Object.entries(search).forEach(([key, value]) => {
    // Only stringify objects and arrays, pass primitives directly
    if (
      value === null ||
      value === undefined ||
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean'
    ) {
      if (value !== null && value !== undefined) {
        params.append(key, String(value))
      }
    } else {
      params.append(key, JSON.stringify(value))
    }
  })

  return `${url}?${params.toString()}`
}
